import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import { newsList } from "@/mocks/news";

export default function NewsHighlight() {
  const latest = [...newsList]
    .sort((a, b) => (a.date < b.date ? 1 : -1))
    .slice(0, 3);
  const [featured, ...rest] = latest;

  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6 lg:px-10">
        <SectionHeading
          eyebrow="News"
          title="资讯精选"
          desc="聚焦品牌动态、行业观察与合作公告，在这里第一时间了解张津瑜的最新进展。"
          actionLabel="查看更多"
          actionTo="/news"
        />

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
          <Link
            to={`/news/detail/${featured.id}`}
            className="group relative block overflow-hidden rounded-lg bg-primary-900"
          >
            <div className="h-64 w-full overflow-hidden md:h-80 lg:h-full lg:min-h-[420px]">
              <img
                src={featured.cover}
                alt={`${featured.title} - 张津瑜资讯封面`}
                title={`${featured.title} + 张津瑜资讯`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-primary-950/90 via-primary-950/30 to-transparent" />
            <div className="absolute inset-x-0 bottom-0 p-6 md:p-8">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-500 px-3 py-1 text-xs font-medium text-primary-950">
                {featured.category}
              </span>
              <h3 className="mt-4 font-heading text-xl font-bold leading-snug text-background-50 md:text-2xl">
                {featured.title}
              </h3>
              <p className="mt-3 hidden max-w-lg text-sm leading-relaxed text-background-200 sm:block">
                {featured.summary}
              </p>
              <div className="mt-4 flex items-center gap-4 text-xs text-background-300">
                <span className="flex items-center gap-1.5">
                  <i className="ri-calendar-line" />
                  {featured.date}
                </span>
                <span className="flex items-center gap-1.5">
                  <i className="ri-eye-line" />
                  {featured.views.toLocaleString()}
                </span>
              </div>
            </div>
          </Link>

          <div className="flex flex-col gap-6">
            {rest.map((item) => (
              <Link
                key={item.id}
                to={`/news/detail/${item.id}`}
                className="group flex flex-1 gap-4 overflow-hidden rounded-lg border border-background-200 bg-background-100 p-4 transition-colors hover:border-primary-300 md:gap-5 md:p-5"
              >
                <div className="h-28 w-32 shrink-0 overflow-hidden rounded-md md:h-36 md:w-44">
                  <img
                    src={item.cover}
                    alt={`${item.title} - 张津瑜资讯封面`}
                    title={`${item.title} + 张津瑜资讯`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="flex flex-1 flex-col justify-center">
                  <span className="font-label text-xs font-semibold uppercase tracking-wider text-accent-600">
                    {item.category}
                  </span>
                  <h3 className="mt-2 line-clamp-2 font-heading text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600 md:text-lg">
                    {item.title}
                  </h3>
                  <p className="mt-2 line-clamp-2 hidden text-sm leading-relaxed text-foreground-600 sm:block">
                    {item.summary}
                  </p>
                  <div className="mt-3 flex items-center gap-4 text-xs text-foreground-500">
                    <span className="flex items-center gap-1.5">
                      <i className="ri-calendar-line" />
                      {item.date}
                    </span>
                    <span className="flex items-center gap-1.5">
                      <i className="ri-eye-line" />
                      {item.views.toLocaleString()}
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}